import { useFormContext } from 'react-hook-form';
import { AiEmailAssistantForm } from '@/schemas/ai-email-assistant';
import { useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Input } from '@/components/Input';
import { captureEvent } from '@/helper/postHog';
import { goals } from '../constants';

export const SectionSubject = () => {
  const {
    watch,
    register,
    setValue,
    formState: { errors }
  } = useFormContext<AiEmailAssistantForm>();
  const messageType = watch('messageType');
  const [showPrompts, setShowPrompts] = useState(false);

  const handleSelectPrompt = (prompt: string) => {
    setValue('messageType', prompt);
    captureEvent('Tivy Email Assistant - Prompt selected', { prompt });
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="mb-1 block text-white">What's the goal you want to achieve with this message?</label>
        <Input
          {...register('messageType')}
          placeholder="Provide a clear and concise goal for the email"
          value={messageType}
          error={errors.messageType?.message}
        />
      </div>

      <div>
        <button
          type="button"
          onClick={() => setShowPrompts(!showPrompts)}
          className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors"
        >
          {showPrompts ? <LuChevronUp /> : <LuChevronDown />}
          {showPrompts ? 'Hide' : 'Show'} suggested topics
        </button>

        {showPrompts && (
          <div className="mt-2 flex flex-wrap gap-2 animate-in fade-in slide-in-from-top-1 duration-200">
            {goals.map(type => (
              <button
                key={type}
                type="button"
                onClick={() => handleSelectPrompt(type)}
                className="px-3 py-1.5 text-sm rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
              >
                {type}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
